/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useHistory, useLocation } from "react-router";
import { ActionType, ResponseCode } from "../models/Enums";
import { format } from "date-fns";
import {
	SaveRecentSearchAuth,
	SearchPatientAuth,
	SearchIntegrationPatientAuth,
	ImportIntegrationPatientAuth,
} from "../services/AuthServices";
import { useRecoilState } from "recoil";
import { networkConnectionStatus } from "../data/atoms";
import NoPatientFound from "../assets/images/no_patient_found.png";
import { IonImg, IonLoading } from "@ionic/react";
interface Props {
	setShowModal: Function;
	setpatientName: Function;
	setIsDisabled: Function;
	// setsearchHistory: Function;
	setsearchData: Function;
	// searchHistoryArray: string[];
	placeholder: string;
	data: any;
	setFilteredData1: Function;
	GetPatientDetails: Function;
	setWord: Function;
	setBusinessType: Function;
	SaveRecentSearch: Function;
	isPccCheck: boolean;
}

const SearchBar: React.FC<Props> = ({
	setShowModal,
	setpatientName,
	setIsDisabled,
	setsearchData,
	placeholder,
	data,
	setFilteredData1,
	GetPatientDetails,
	setWord,
	setBusinessType,
	SaveRecentSearch,
	isPccCheck,
}) => {
	const [filteredData, setFilteredData] = useState<any[]>([]);
	const [patientsList, setpatientsList] = useState<string[]>([]);
	const [wordEntered, setWordEntered] = useState("");
	const [defaultPatient, setDefaultPatient] = useState("");
	const [pccPageNumber, setPccPageNumber] = useState(1);
	const [pccTotalRecords, setPccTotalRecords] = useState(0);
	const [isFetchingMorePcc, setIsFetchingMorePcc] = useState(false);
	const [showPccPatientLoading, setShowPccPatientLoading] = useState(false);
	const [ShowNetWorkRecoil, setShowNetWorkRecoil] = useRecoilState(
		networkConnectionStatus
	);
	const {
		formState: { errors },
	} = useForm({
		defaultValues: {
			text: "",
			password: "",
		},
	});
	let history = useHistory();
	const location = useLocation();
	const pccDebounceRef = useRef<ReturnType<typeof setTimeout> | null>(null);
	async function searchPcc(searchWord: string, page: number = 1) {
		if (page > 1) {
			setIsFetchingMorePcc(true);
		} else {
			setShowPccPatientLoading(true);
		}
		try {
			const splitOnSpace = searchWord.trim().split(" ").filter(Boolean);
			await SearchIntegrationPatientAuth({
				mode: 1,
				patientFirstName: splitOnSpace[0],
				patientLastName:
					splitOnSpace.length > 1
						? splitOnSpace.slice(1).join(" ")
						: undefined,
				pageNumber: page,
				pageSize: 25,
			})
				.then(async function (response) {
					if (response!.data.responseCode === ResponseCode.Success) {
						setPccPageNumber(page);
						setPccTotalRecords(response!.data.totalPatientRecords || 0);
						if (page === 1) {
							setsearchData(response!.data.patients);
							setDefaultPatient(
								response!.data.patients.length
									? ""
									: "No matches in PointClickCare"
							);
						} else {
							setsearchData((prev: any[]) => [
								...prev,
								...response!.data.patients,
							]);
						}
					} else if (page === 1) {
						setsearchData([]);
						setPccTotalRecords(0);
						setDefaultPatient(
							response!.data.responseMessage ||
								"Could not reach PointClickCare. Try again."
						);
					}
				})
				.catch((error) => {});
		} catch (error) {
			console.error(error);
		} finally {
			if (page > 1) {
				setIsFetchingMorePcc(false);
			} else {
				setShowPccPatientLoading(false);
			}
		}
	}

	function loadMorePcc() {
		if (
			!isPccCheck ||
			isFetchingMorePcc ||
			wordEntered.length < 3 ||
			data.length >= pccTotalRecords
		) {
			return;
		}
		searchPcc(wordEntered, pccPageNumber + 1);
	}

	function handleSearchResultScroll(event: React.UIEvent<HTMLDivElement>) {
		if (!isPccCheck) return;
		const el = event.currentTarget;
		if (el.scrollHeight - el.scrollTop - el.clientHeight < 40) {
			loadMorePcc();
		}
	}
	async function handleFilter(event: { target: { value: any } }) {
		if (!navigator.onLine) {
			setShowNetWorkRecoil({ isShown: true });
			return;
		}
		const searchWord = event.target.value;
		setWordEntered(searchWord);
		setWord(searchWord);
		// console.log("searchWord", searchWord)
		if (isPccCheck) {
			if (pccDebounceRef.current) {
				clearTimeout(pccDebounceRef.current);
				pccDebounceRef.current = null;
			}
			if (searchWord.length >= 3) {
				pccDebounceRef.current = setTimeout(() => {
					searchPcc(searchWord);
				}, 500);
			} else {
				setDefaultPatient("");
				setFilteredData([]);
				setsearchData([]);
				setPccPageNumber(1);
				setPccTotalRecords(0);
			}
			return;
		}
		if (searchWord.length >= 3) {
			try {
				const splitOnSpace = searchWord.split(" ").filter(Boolean);
				await SearchPatientAuth({
					PageNumeber: 1,
					PageSize: 1000,
					LoggedInUserID: 0,
					SearchName: splitOnSpace[0],
					LastName: splitOnSpace[1] === undefined ? "" : splitOnSpace[1],
				})
					.then(async function (response) {
						if (response!.data.responseCode !== 0) {
							setBusinessType(response!.data.businessType);
							setsearchData(response!.data.patients);
							if (!response!.data.patients.length) {
								setDefaultPatient("No Record Found");
							} else {
								setDefaultPatient("");
							}
						} else {
							console.log(errors);
						}
					})
					.catch((error) => {});
			} catch (error) {
				console.error(error);
			}
		} else {
			setDefaultPatient("");
			setFilteredData([]);
			setsearchData([]);
		}
	}

	async function handleImport(externalId: number) {
		if (!navigator.onLine) {
			setShowNetWorkRecoil({ isShown: true });
			return;
		}
		setShowPccPatientLoading(true);
		try {
			await ImportIntegrationPatientAuth({ externalId }).then(
				async function (response) {
					if (response!.data.responseCode === ResponseCode.Success) {
						GetPatientDetails(
							response!.data.syncedPatientLocalId,
							true,
							response!.data.patient?.fullName,
							response!.data.patient?.dob
						);
						return;
					} else if (
						response!.data.responseCode === ResponseCode.UserDoesNotExist
					) {
						setDefaultPatient(
							"This patient is no longer available in PointClickCare."
						);
					} else {
						setDefaultPatient(
							response!.data.responseMessage || "Could not import patient."
						);
					}
					setShowPccPatientLoading(false);
				}
			);
		} catch (error) {
			console.error(error);
			setShowPccPatientLoading(false);
		}
	}

	// async function SaveRecentSearch(fullName: string, patientid: number) {
	//   try {
	//     await SaveRecentSearchAuth({
	//       loggedInUserID: 0,
	//       search: {
	//         fullName: fullName,
	//         patientid: patientid,
	//       },
	//     })
	//       .then(async function (response) {
	//         if (response!.data.isResponseSuccessfull) {
	//         } else { }
	//       })
	//       .catch((error) => {
	//         history.push("/confirmation", {
	//           actionType: ActionType.FailureAPIResponse,
	//         });
	//       });
	//   } catch (error) {
	//     history.push("/confirmation", {
	//       actionType: ActionType.FailureAPIResponse,
	//     });
	//     console.error(error);
	//   }
	// }
	useEffect(() => {
		if (window.location.href.includes("home")) {
			setFilteredData([]);
		}
		setWordEntered("");
		setDefaultPatient("");
	}, [location]);

	useEffect(() => {
		if (pccDebounceRef.current) {
			clearTimeout(pccDebounceRef.current);
			pccDebounceRef.current = null;
		}
		setWordEntered("");
		setFilteredData([]);
		setDefaultPatient("");
		setPccPageNumber(1);
		setPccTotalRecords(0);
		setIsFetchingMorePcc(false);
		setShowPccPatientLoading(false);
	}, [isPccCheck]);

	useEffect(() => {
		return () => {
			if (pccDebounceRef.current) {
				clearTimeout(pccDebounceRef.current);
			}
		};
	}, []);

	useEffect(() => {
		const newFilter = data.filter((value: any) => {
			return value.fullName.toLowerCase().includes(wordEntered.toLowerCase());
		});
		debugger;
		if (wordEntered === "") {
			setFilteredData1([]);
			setFilteredData([]);
			setDefaultPatient("");
			// setsearchData([])
		} else {
			// console.log("newFilter :", newFilter);
			setFilteredData1(newFilter);
			setFilteredData(newFilter);
		}
	}, [data]);
	// console.log("filteredData", filteredData)
	return (
		<div className="search-wrap">
			<IonLoading
				isOpen={showPccPatientLoading}
				message={"Please wait..."}
			/>
			<div className="searchInputs">
				<input
					type="text"
					placeholder={placeholder}
					value={wordEntered}
					onChange={handleFilter}
					className={
						filteredData.length != 0 && wordEntered.length !== 0
							? "search-input search-input-open"
							: "search-input"
					}
				/>
				<div className="search-patient">
					<h6>444</h6>
					<h6>444</h6>
					<h6>444</h6>
					<h6>444</h6>
					<h6>444</h6>
				</div>
			</div>

			<div
				className={`${
					filteredData.length !== 0 && wordEntered.length !== 0
						? "search-result-padding"
						: ""
				} search-result`}
				onScroll={handleSearchResultScroll}>
				{
					filteredData.length !== 0 &&
						wordEntered.length > 0 &&
						filteredData.map((value, key) => {
							if (isPccCheck) {
								return (
									<div
										className={`dataItem pcc-data-item${
											value.dobInvalid ? " pcc-data-item-disabled" : ""
										}`}
										key={"pcc-patient-" + key}>
										<a
											target="_self"
											onClick={() => {
												if (value.dobInvalid) return;
												if (value.isIntegrationIdExist) {
													if (navigator.onLine) {
														setShowPccPatientLoading(true);
													}
													GetPatientDetails(
														value.patientLocalId,
														true,
														value.fullName,
														value.dob
													);
												} else {
													handleImport(value.externalId);
												}
											}}>
											<p>
												<span
													className={
														value.isIntegrationIdExist
															? "pcc-existing-patient"
															: ""
													}>
													{value.fullName}
												</span>
											</p>
											<div className="date-new-values">
												<span>
													{value.dobInvalid
														? "DOB unavailable"
														: value.dobFormatted ||
														  format(new Date(value?.dob), "MM/dd/yyyy")}
												</span>
											</div>
										</a>
									</div>
								);
							}
							return (
								<a
									className="dataItem"
									target="_self"
									key={"patient-" + key}
									onClick={() => {
										debugger;
										setShowModal(false);
										setpatientName(value.fullName);
										setIsDisabled(false);
										localStorage.setItem("patientSearched", value.fullName);
										localStorage.setItem("patientSearchedID", value.id);
										console.log("id: ", value.serverId);
										localStorage.setItem("patientName", value.fullName);
										localStorage.setItem(
											"searchHistory",
											value.fullName +
												" | " +
												(localStorage.getItem("searchHistory") == null
													? ""
													: localStorage.getItem("searchHistory"))
										);
										localStorage.setItem("patientMasterID", value.serverId);
										GetPatientDetails(
											value.serverId,
											true,
											value.fullName,
											value.dob
										);
									}}>
									<p>
										<span>{value.fullName}</span>
									</p>
									<div className="date-new-values">
										<span>{format(new Date(value?.dob), "MM/dd/yyyy")}</span>
									</div>
								</a>
								);
							})
					//   : wordEntered.length > 0 &&
					//  <p className={`${defaultPatient == "" ? "no-patient-found" : "no-record"}`} >{defaultPatient}</p>
				}
				{isPccCheck && isFetchingMorePcc && (
					<p className="pcc-loading-more">Loading more...</p>
				)}
			</div>
			{filteredData.length == 0 && defaultPatient !== "" && (
				<div className="no-patient-found">
					<div className="d-flex flex-column justify-content-center align-items-center">
						<IonImg
							src={NoPatientFound}
							alt="paperIcon"
							placeholder={undefined}></IonImg>
						<h6>No Patients Found</h6>
					</div>
				</div>
			)}
		</div>
	);
};
export default SearchBar;
